/* 
  Standard approx. for control point length to achieve
  an almost perfect circle: https://spencermortensen.com/articles/bezier-circle/
*/
export const BEZIER_CIRCLE_CP_LENGTH = 0.5523
